<template>
    <div class="is-hoverable buttons">
        <hr />
        <a
            v-for="(answer, index) in answers"
            :key="index"
            :class="{
                'is-success': isAnsweredRight(answer),
                'is-danger': isAnsweredWrong(answer),
            }"
            class="lb-answer"
            @click="selectAnswer(answer)"
        >
            {{ answer.value }}
        </a>
    </div>
</template>

<script>
import _ from 'underscore';
export default {
    props: {
        answers: {
            type: Array,
            default() {
                return [];
            },
        },
    },
    data() {
        return {
            selectedAnswers: [],
        };
    },
    computed: {
        correctAnswers() {
            return _.filter(this.answers, (answer) => {
                return answer.correct == true;
            });
        },
        isAnsweredRight() {
            return (answer) => {
                return (
                    _.contains(this.selectedAnswers, answer) &&
                    _.contains(this.correctAnswers, answer)
                );
            };
        },
        isAnsweredWrong() {
            return (answer) => {
                return (
                    _.contains(this.selectedAnswers, answer) &&
                    !_.contains(this.correctAnswers, answer)
                );
            };
        },
    },
    methods: {
        selectAnswer(answer) {
            this.selectedAnswers.push(answer);
            // console.log('emitting single answer', answer);
            this.$emit('answer', { answer, correct: answer.correct });
        },
    },
};
</script>

<style></style>
